import { render, staticRenderFns } from "./AltaPacientesBbva.vue?vue&type=template&id=43889fe2&scoped=true"
import script from "./AltaPacientesBbva.vue?vue&type=script&lang=js"
export * from "./AltaPacientesBbva.vue?vue&type=script&lang=js"
import style0 from "./AltaPacientesBbva.vue?vue&type=style&index=0&id=43889fe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43889fe2",
  null
  
)

export default component.exports